import { jsx as _jsx } from "react/jsx-runtime";
import isEmpty from 'lodash/isEmpty';
import React, { useMemo } from 'react';
import NotImplemented from '../NotImplemented';
import PaymentDetailsComponent from './PaymentDetailsComponent';
import safelyStringifyJSON from '../../utils/safelyStringifyJSON';
import { createObjectFromProps } from '../../utils/object';
import { useAppName } from '../../utils/sitecoreContext';
import { variant1 } from './utils/constants';
const PaymentDetailsComponentMap = ({ variant: propVariant, componentName, ...fields }) => {
    const appName = useAppName();
    let variant;
    let mappedFields = fields || {};
    switch (appName) {
        default:
            variant = variant1;
            break;
    }
    mappedFields = useMemo(() => createObjectFromProps(mappedFields), [safelyStringifyJSON(mappedFields)]);
    const appNameConfig = useMemo(() => ({ variant: propVariant !== null && propVariant !== void 0 ? propVariant : variant, ...mappedFields }), [propVariant, variant, mappedFields]);
    if (!fields || isEmpty(fields) || !mappedFields) {
        return _jsx(NotImplemented, { name: "Bap PaymentDetailsComponent" });
    }
    return _jsx(PaymentDetailsComponent, { appNameConfig: appNameConfig, componentName: componentName });
};
export default PaymentDetailsComponentMap;
